import React from "react";
import { Box } from "@mui/material";
import ToggleRow from "../../../../common/ToggleRow";
import AgentConfigSection from "../../AgentConfigSection";

export default function TranscriptVisibilitySection({
  showSystemPromptInChat,
  setShowSystemPromptInChat,
  showToolCallsAndOutputsInChat,
  setShowToolCallsAndOutputsInChat,
  showInterAgentMessagesInChat,
  setShowInterAgentMessagesInChat,
  showWorkflowProvenanceInChat,
  setShowWorkflowProvenanceInChat,
  showSchedulingActivityInChat,
  setShowSchedulingActivityInChat,
  showSessionOperationalMetaInChat,
  setShowSessionOperationalMetaInChat,
  showSupervisorControlMessagesInChat,
  setShowSupervisorControlMessagesInChat,
  enableHumanTakeoverMode,
  setEnableHumanTakeoverMode,
}) {
  const toggles = [
    {
      checked: showSystemPromptInChat,
      onChange: setShowSystemPromptInChat,
      title: "Show system prompt block in chat UI",
      description:
        "Off hides the expandable system prompt section from responders.",
    },
    {
      checked: showToolCallsAndOutputsInChat,
      onChange: setShowToolCallsAndOutputsInChat,
      title: "Show tool calls and tool outputs in chat UI",
      description:
        "Off hides internal tool activity cards while preserving form interactions.",
    },
    {
      checked: showInterAgentMessagesInChat,
      onChange: setShowInterAgentMessagesInChat,
      title: "Show inter-agent routing messages",
      description:
        "Off hides agent-to-agent message cards and routing chatter from responders.",
    },
    {
      checked: showWorkflowProvenanceInChat,
      onChange: setShowWorkflowProvenanceInChat,
      title: "Show workflow provenance cards",
      description:
        "Off hides workflow/source context wrappers and keeps the transcript focused on plain conversation content.",
    },
    {
      checked: showSchedulingActivityInChat,
      onChange: setShowSchedulingActivityInChat,
      title: "Show scheduling activity",
      description:
        "Off hides schedule-message tool actions and timing activity cards.",
    },
    {
      checked: showSessionOperationalMetaInChat,
      onChange: setShowSessionOperationalMetaInChat,
      title: "Show session operational metadata",
      description:
        "Off hides session email/thread metadata and other operational UI details.",
    },
    {
      checked: showSupervisorControlMessagesInChat,
      onChange: setShowSupervisorControlMessagesInChat,
      title: "Show supervisor control messages",
      description:
        "Off hides supervisor review/takeover control messages from responder transcripts.",
    },
    {
      checked: enableHumanTakeoverMode,
      onChange: setEnableHumanTakeoverMode,
      title: "Enable human takeover mode",
      description:
        "Lets operators pause AI responses per session in internal chat UI so humans can converse directly.",
    },
  ];

  return (
    <AgentConfigSection id="transcriptVisibility" sx={{ mt: 2.5 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {toggles.map((toggle) => (
          <ToggleRow
            key={toggle.title}
            checked={toggle.checked}
            onChange={toggle.onChange}
            title={toggle.title}
            description={toggle.description}
          />
        ))}
      </Box>
    </AgentConfigSection>
  );
}
